import { COMPANY, DISCLAIMER, addressLine } from "@/lib/company";

// The legal band that sits at the bottom of every page.
//
// Carries the licence details because we are a licensed UAE entity and the
// people we ask for money are entitled to know who they are paying. It is a
// separate component from the marketing footers on purpose: those differ per
// product, this must be identical everywhere, and a legal notice that drifts
// between pages is worse than one that only appears once.
export default function CompanyFooter({ accent = "#00E676" }) {
  const year = new Date().getFullYear();

  return (
    <div className="relative z-10 border-t border-white/[0.06] bg-black/60 backdrop-blur-xl">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
        <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-2">
            <p className="text-sm font-semibold tracking-tight text-white">{COMPANY.legalName}</p>
            <p className="mt-3 max-w-sm text-sm leading-6 text-gray-500">{addressLine()}</p>
            <dl className="mt-4 space-y-1 text-xs text-gray-600">
              <div className="flex gap-2">
                <dt className="text-gray-700">Licence</dt>
                <dd className="text-gray-500">{COMPANY.licenceNumber} · {COMPANY.legalStatus}</dd>
              </div>
              <div className="flex gap-2">
                <dt className="text-gray-700">Issued by</dt>
                <dd className="text-gray-500">{COMPANY.issuingAuthority}</dd>
              </div>
            </dl>
          </div>

          <div>
            <p className="text-xs font-semibold uppercase tracking-wider text-gray-600">Products</p>
            <ul className="mt-4 space-y-2.5 text-sm">
              <li><a href="/alphabot" className="text-gray-500 hover:text-white transition-colors">Alphabot</a></li>
              <li><a href="/trubon" className="text-gray-500 hover:text-white transition-colors">Trubon</a></li>
              <li><a href="/roar" className="text-gray-500 hover:text-white transition-colors">Roar</a></li>
            </ul>
          </div>

          <div>
            <p className="text-xs font-semibold uppercase tracking-wider text-gray-600">Company</p>
            <ul className="mt-4 space-y-2.5 text-sm">
              <li><a href="/legal" className="text-gray-500 hover:text-white transition-colors">Legal &amp; risk</a></li>
              <li>
                <a href={`mailto:${COMPANY.supportEmail}`} className="text-gray-500 hover:text-white transition-colors break-all">
                  {COMPANY.supportEmail}
                </a>
              </li>
              <li>
                <a href={COMPANY.whatsapp} target="_blank" rel="noopener noreferrer" style={{ color: accent }} className="hover:opacity-80 transition-opacity">
                  WhatsApp
                </a>
              </li>
            </ul>
            <p className="mt-5 text-xs leading-5 text-gray-700">
              Licensed activities: software design, software trading and IT consultancy.
            </p>
          </div>
        </div>
      </div>

      <div className="border-t border-white/[0.06]">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-7">
          <p className="max-w-4xl text-xs leading-5 text-gray-600">{DISCLAIMER}</p>
          <p className="mt-4 text-xs text-gray-700">
            © {year} {COMPANY.legalName}. All rights reserved.
          </p>
        </div>
      </div>
    </div>
  );
}
